import React, { useState, useEffect } from 'react'
import ButtonContainer from '../Components/ButtonContainer';
import COLORS from '../Colors';
import '../Styles/StartEndScreen.css';
import { withRouter } from "react-router-dom";

import { PATH_NAMES } from '../Utilities/Constants';
import * as api from '../Scripts/Api';
import * as questionnaireData from '../Scripts/QuestionnaireData';
import CustomInput from '../Components/CustomInput';
import { CognitoHelper } from '../Utilities/CognitoHelper';

function setAgeLimit() {
  const minAge = 18;
  const maxAge = 100;

  let youngestBirthday = getBirthdayByAgeInYears(minAge);
  let oldestBirthday = getBirthdayByAgeInYears(maxAge);

  console.log("youngest birthday: ", youngestBirthday);
  console.log("oldest birthday: ", oldestBirthday);
}

function getBirthdayByAgeInYears(ageInYears) {
  let d = new Date();
  let year = d.getFullYear();
  let month = d.getMonth();
  let day = d.getDate();
  return new Date(year - ageInYears, month, day).toISOString().split("T")[0];
}

function generateAgeOptions() {
  const arr = [];

  const startAge = 18;
  const endAge = 100;

  for (let i = startAge; i <= endAge; i++) {
    arr.push(<option value={i}>{i}</option>);
  }

  return arr;
}

function Staff(props) {
  const [questionAnswered, setQuestionAnswered] = useState(false);
  const [providers, setProviders] = useState([]);

  const [isEntered_Provider, setIsEntered_Provider] = useState(false);

  const [isEntered_DOB, setIsEntered_DOB] = useState(false);
  const [isEntered_SEX, setIsEntered_SEX] = useState(false);
  const [isValid_DOB, setIsValid_DOB] = useState(false);

  const [isEntered_FirstName, setIsEntered_FirstName] = useState(false);
  const [isEntered_LastName, setIsEntered_LastName] = useState(false);

  const [assessmentData, setAssessmentData] = useState({
    assessmentId: "",
    providerEmail: "",
    ptFirstName: "",
    ptLastName: "",
    ptDateOfBirth: "",
    ptAge: "",
    ptSex: "",
    ptEmail: "",
    ptScreenerId: sessionStorage.getItem('screening_id')
  });

  const includeName = ['', null, undefined, 'False', 'false'].includes(process.env.REACT_APP_OMIT_PATIENT_NAME)
  const includeDateOfBirth = ['', null, undefined, 'False', 'false'].includes(process.env.REACT_APP_OMIT_PATIENT_DOB)
  const omitEmailAddress = ['', null, undefined, 'False', 'false'].includes(process.env.REACT_APP_INCLUDE_PATIENT_EMAIL)

  useEffect(() => {
    if (includeName === false) {
      assessmentData.ptFirstName = 'Omitted First Name'
      assessmentData.ptLastName = 'Omitted Last Name'

      setIsEntered_FirstName(true)
      setIsEntered_LastName(true)
    }

    console.log('omitEmailAddress')
    console.log(omitEmailAddress)

    if (omitEmailAddress === false) {
      const cognitoHelper = new CognitoHelper()

      const user = cognitoHelper.getUser()

      user.getSession(function (error, session) {
        console.log('user.getSession')
        console.log(`e: ${error}`)
        console.log(`s: ${session}`)
        console.log(session)

        console.log('omitEmailAddress USER')
        console.log(user)

        if (error) {
          console.log(error)
        } else {
          user.getUserAttributes(function (err, result) {
            if (err) {
              console.log(err);
              return;
            }

            console.log('result');
            console.log(result);

            for (let i = 0; i < result.length; i++) {
              if (result[i].getName() === 'email') {
                assessmentData.ptEmail = result[i].getValue()
              }
            }

            console.log('assessmentData')
            console.log(assessmentData)
          });
        }
      })
    }
  }, [])

  useEffect(() => {
    setQuestionAnswered(allQuestionsAnswered())
  }, [assessmentData])

  useEffect(() => {
    setAgeLimit();

    const fetchData = async () => {
      console.log('fetching data...')
      const providerArray = await api.get_primary_care_providers()
      providerArray.unshift({ id: '-1', email: '', fullName: 'Select a Provider' })
      setProviders(providerArray);
    }
    // call the function
    fetchData()
      .catch(console.error);

    console.log('done fetching data')

  }, []);

  function clickNext() {
    setQuestionAnswered(allQuestionsAnswered())

    if (!allQuestionsAnswered2()) {
      alert('not all input provided')
    }
    else {
      sessionStorage.setItem("provider_email", assessmentData.providerEmail);

      const createAssessment = async (input) => {
        if (includeDateOfBirth) {
          sessionStorage.setItem("birthtext", input.ptDateOfBirth)
          let ptAge = questionnaireData.convertBirthdayToAge(input.ptDateOfBirth)

          input.ptAge = `${ptAge}`
        }

        console.log("[Create Assessment] input: ", input)
        const assessmentId = await api.create_assessment(input);
        console.log("[Create Assessment] assessmentId", assessmentId);
        sessionStorage.setItem("assessmentId", assessmentId);

      }

      const nextPage = async () => {
        console.log("pushing ", PATH_NAMES.LANGUAGE, " onto history");
        props.history.push({ pathname: PATH_NAMES.LANGUAGE });
      }

      console.log('createAssessment(assessmentData)')
      console.log(assessmentData)

      // call the function
      createAssessment(assessmentData)
        .catch(console.error)
        .then(() => console.log('assessment created, moving to WELCOME.'))
        .then(() => nextPage())
    }
  }

  const handleSelectChange = (event) => {
    console.log("setting selected provider: ", event.target.value)

    if (event.target.value !== "") {
      setIsEntered_Provider(true);
    }
    else {
      setIsEntered_Provider(false);
    }

    setAssessmentData((prevData) => ({
      ...prevData,
      providerEmail: event.target.value
    }))

    // setQuestionAnswered(allQuestionsAnswered())
  }

  const handleAgeSelectChange = (event) => {
    console.log("setting selected provider: ", event.target.value)

    let dobString = ''

    if (event.target.value !== "") {
      let birthDate = new Date(Date.now() - (parseInt(event.target.value) * 31557600 * 1000))

      setIsEntered_DOB(true)

      dobString = birthDate.toISOString().substring(0, 10)
    } else {
      setIsEntered_DOB(false)
    }

    setAssessmentData((prevData) => ({
      ...prevData,
      ptAge: event.target.value,
      ptDateOfBirth: dobString
    }))

    // setQuestionAnswered(allQuestionsAnswered())
  }

  function allQuestionsAnswered2() {
    console.log(`allQuestionsAnswered2: P: ${isEntered_Provider} -- FN: ${isEntered_FirstName} -- LN: ${isEntered_LastName}`)
    console.log(` S: ${isEntered_SEX} -- DOB: ${isEntered_DOB}`)

    let retVal =
      (isEntered_Provider
        && isEntered_FirstName
        && isEntered_LastName
        && isEntered_SEX
        && isEntered_DOB)
    console.log('all questions anwered: ', retVal)
    return retVal;
  }

  function allQuestionsAnswered() {
    console.log(`allQuestionsAnswered: P: ${assessmentData.providerEmail} -- FN: ${assessmentData.ptFirstName} -- LN: ${assessmentData.ptLastName}`)
    console.log(` S: ${assessmentData.ptSex} -- DOB: ${assessmentData.ptDateOfBirth}`)

    let retVal =
      (assessmentData.providerEmail.length > 0)
      && (assessmentData.ptFirstName.length > 0)
      && (assessmentData.ptLastName.length > 0)
      && (assessmentData.ptSex.length > 0)
      && (assessmentData.ptDateOfBirth.length > 0)
    console.log('all questions anwered: ', retVal)
    return retVal;
  }

  function validateDOB(dob) {
    // let date_of_birth = new Date(dob);
    // if (date_of_birth)
    // console.log('dob type:', typeof(dob))
    const youngestBirthday = Date.parse(getBirthdayByAgeInYears(20));
    const oldestBirthday = Date.parse(getBirthdayByAgeInYears(100));

    let dob_val;

    try {
      dob_val = Date.parse(dob);
      setIsEntered_DOB(true);
    } catch (error) {
      if (isValid_DOB) {
        setIsEntered_DOB(true);
        setIsValid_DOB(false);
      }
      return false;
    }

    // console.log('oldestBirthday.valueOf(): ', oldestBirthday.valueOf())
    // console.log('dob_val.valueOf(): ', dob_val.valueOf())
    // console.log('youngestBirthday.valueOf(): ', youngestBirthday.valueOf())

    if (dob_val.valueOf() >= oldestBirthday.valueOf()) {
      if (dob_val.valueOf() <= youngestBirthday.valueOf()) {
        console.log('dob is valid');
        setIsEntered_DOB(true);
        setIsValid_DOB(true);
        return true;
      }
      else {
        console.log('dob is too young');
        setIsEntered_DOB(true);
        setIsValid_DOB(false);
        return false;
      }
    }
    else {
      console.log('dob is too old');
      setIsEntered_DOB(true);
      setIsValid_DOB(false);
      return false;
    }
  }

  const handleInputChange = (e) => {
    // console.log('e.', e.nativeEvent.srcElement.name)

    const { name, value } = e.target;
    console.log("input changed: ", name, ':', value)

    let updateIsValid = false;

    switch (name) {
      case 'ptDateOfBirth':
        updateIsValid = validateDOB(value)
        break;
      case 'ptFirstName':
        setIsEntered_FirstName(value.length > 0);
        break;
      case 'ptLastName':
        setIsEntered_LastName(value.length > 0);
        break;
      case 'ptSex':
        setIsEntered_SEX(value === "Male" || value === "Female");
        break;
      default:
        // code block
        console.log('no validation, fieldname:' + name)
    }

    console.log('update is valid:', updateIsValid);

    setAssessmentData((prevData) => ({
      ...prevData,
      [name]: value,
    })) // then(setQuestionAnswered(allQuestionsAnswered()))

    // setQuestionAnswered(allQuestionsAnswered())
  };

  var fieldComponent =
    <div>
      <select value={assessmentData.providerEmail} onChange={handleSelectChange}>
        {providers.map((p) => (
          p.id === '-1' ?
            <option key={p.id} value={p.email}>{p.fullName}</option>
            :
            <option key={p.id} value={p.email}>{p.fullName + '(' + p.email + ')'}</option>
        ))}
      </select>
      {isEntered_Provider ? '✅' : '***'}
      <br />

      {includeName ? <div>
        <label htmlFor="ptFirstName">Patient First Name: </label>
        <CustomInput id="ptFirstName"
          type={'text'}
          onChange={handleInputChange}
          name="ptFirstName"
          value={assessmentData.ptFirstName}
          placeholder={'patient first name'}
        />{isEntered_FirstName ? '✅' : '***'}
        <br />
        <br />

        <label htmlFor="ptLastName">Patient Last Name: </label>
        <CustomInput id="ptLastName"
          type={'text'}
          onChange={handleInputChange}
          name="ptLastName"
          value={assessmentData.ptLastName}
          placeholder={'patient last name'}
        />{isEntered_LastName ? '✅' : '***'}
        <br />
        <br />
      </div> : <div></div>}

      {includeDateOfBirth ? <div>
        <label htmlFor="ptDOB">Patient Date of Birth: </label>
        <input id="ptDOB"
          type={'date'}
          onChange={handleInputChange}
          name="ptDateOfBirth"
          value={assessmentData.ptDateOfBirth}
          min={getBirthdayByAgeInYears(100)}
          max={getBirthdayByAgeInYears(20)}
        /> {isEntered_DOB ? (isValid_DOB ? '✅' : '❌') : '***'}
        <br />
        <br />
      </div> :
        <div>
          <label htmlFor="ptAge">Patient Age:</label>
          <select name='ptAge' onChange={handleAgeSelectChange} value={assessmentData.ptAge}>
            <option value=''>Select Age</option>
            {generateAgeOptions()}
          </select>
        </div>}

      <label>Patient sex: </label>
      <br />

      <label htmlFor="ptSexMale">Male</label>
      <CustomInput id="ptSexMale"
        type={'radio'}
        onChange={handleInputChange}
        name="ptSex"
        value="Male"
        checked={assessmentData.ptSex === "Male"}
      />
      <br />
      <label htmlFor="ptSexFemale">Female</label>
      <CustomInput id="ptSexFemale"
        type={'radio'}
        onChange={handleInputChange}
        name="ptSex"
        value="Female"
        checked={assessmentData.ptSex === "Female"}
      />

      <br />

    </div>
  return (
    <>
      <div className='card'>
        <p className='card-text'>
          Please select the primary care provider:
        </p>
        {fieldComponent}
        <ButtonContainer
          colors={[COLORS.green]}
          buttonTexts={['Save and Continue']}
          buttonType={questionAnswered ? 'filled' : 'empty'}
          onClick={() => clickNext()}

          // not working for some reason...
          showButton={questionAnswered}

        />
      </div>
    </>
  );
}
export default withRouter(Staff);



